<template>
    <div class="asta-filter"><!-- classnamnet är påhittat -->
        TODO: Filter<br />

        <!--debug-test-->
        |{{ store.filter.utbildningstyp }}|<br />
        <button @click="triggerFilterUpdated('program')"
            :class="{ 'selected': store.filter.utbildningstyp == 'program' }">Program</button>
        <button @click="triggerFilterUpdated('kurs')"
            :class="{ 'selected': store.filter.utbildningstyp == 'kurs' }">Kurs</button>
        <button @click="triggerDisplayUpdated()">Trigger display changed</button>
        <!--/debug-test-->
    </div>
</template>
<script setup lang="ts">
import { defineEmits } from 'vue';
import type { AstaDisplaySettings, AstaFilterSettings } from '../../types/AstaTypes';

import useAstaStore from '../stores/AstaStore';
const store = useAstaStore();

const emit = defineEmits<{
    (event: "displayChange", settings: AstaDisplaySettings): void,
    (event: "filterChange", settings: AstaFilterSettings): void,
}>();

const triggerDisplayUpdated = () => {
    emit('displayChange', {
        vygroup: 'antagna',
        vy: 'antagningspoang-urv1',
        urvalsgrupper: ['BI', 'HP']
    });
};
const triggerFilterUpdated = (utbildningstyp: 'program' | 'kurs') => {
    const newFilter = { ...store.filter, utbildningstyp };
    store.setFilter(newFilter);
    emit('filterChange', newFilter);
};
</script>